import { render, staticRenderFns } from "./ShortcutsPanel.vue?vue&type=template&id=11bbaeb6&scoped=true"
import script from "./ShortcutsPanel.vue?vue&type=script&lang=js"
export * from "./ShortcutsPanel.vue?vue&type=script&lang=js"
import style0 from "./ShortcutsPanel.vue?vue&type=style&index=0&id=11bbaeb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bbaeb6",
  null
  
)

export default component.exports